export default {
    SET_IMOVEIS(state, imoveis) {
        state.data = imoveis;
    },
    SET_IMOVEIS_OPTIONS(state, options) {
        state.submitOptions = options;
    }
}